/**
 * @file: 组件快捷移动
 * @author: xiaolong.huang@dmall.com
 */

import { move } from './move';

export default {
    move
}
